import React from 'react';

import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { TabelaCampanha } from '../../components/TabelaCampanha';

export default function CampanhaPage() {

    return (
        <>           
            <MenuMain >
                <TabelaCampanha />
            </MenuMain>
            <AppFooter />    
        </>
    );
}
